import { DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessagesStatus, MessagesTitles } from './../../../models/messages';
import moment from 'moment';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { EmpresasService } from 'app/services/empresas/empresas.service';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
  MatChipInputEvent,
  MatAutocompleteSelectedEvent,
  MatAutocomplete
} from "@angular/material";
import Swal from 'sweetalert2';
import { GuiasService } from 'app/services/guias/guias.service';
import { HttpErrorResponse } from '@angular/common/http';
import { FirmaElectronicaService } from '../../../services/firma-electronica/firma-electronica.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { ComunicacionService } from 'app/services/comunicacionService/comunicacion.service';
import { environment } from 'environments/environment';

declare var $: any;

export const MY_FORMATS  ={
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
@Component({
  selector: 'app-nuevo-pagare',
  templateUrl: './nuevo-pagare.component.html',
  styleUrls: ['./nuevo-pagare.component.scss'],
  providers:[MessagesTitles,MessagesStatus,{
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  },
  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class NuevoPagareComponent implements OnInit {

  abrirAgregarAdquirente : boolean;
  loading:boolean = false;
  isLoading = true;
  user:any;
  formTipoP : FormGroup;
  formDataEnviar : FormGroup;
  dataEnviar : any = {};
  Fecha = moment();
  idContratoM : any;
  tipoP:any;
  now = moment();
  save:boolean = false;
  rProvCombo : any =[];
  idEmpresa:any;

  error : boolean = false;

  rAvalCombo : any = [];

  selectedItems = [];
  selectedItemsCLI = [];

  dropdownSettings2 = {};
  dropdownSettings4 = {};
  requiredField2: boolean = true;
  requiredField3: boolean = true;
  inputDefault2 : any = [];
  searchField2:string ="";
  dropdownList2 = [];
  selectedItems2 = [];

  tipoProceso: any = 141;
  dataEnviarKeynua :any={};
  dataContract : any = [];
  abrirAgregarAvalJ : boolean = false;
  AvalJuridicos : any = [] ;

  AvalID = new FormControl();
  AvalArr;
  filteredAval: Observable<any[]>;
  id;
  AvalTemporal: any = {}
  search:boolean;
  allprueba:string[]=[];
  repaval: any = [];
  repavalCrt = new FormControl('',[Validators.required]);
  idAval ="" ;
  dataRepAvalJ: any =[];
  filteredRepAvalJ: Observable<string[]>;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  AvalFilter:any =[];
  AvalFilter2:any =[];  

  ID_PAGARE_COMPLETO=environment.TIPO_PAGARE.COMPLETO;
  ID_PAGARE_INCOMPLETO=environment.TIPO_PAGARE.INCOMPLETO;

  @Output() cerrarNuevoP: EventEmitter<boolean> = new EventEmitter();
  @Output() refresh: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('AvalInput',{static: true}) AvalInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto2',{static: true}) matAutocomplete: MatAutocomplete;
  
  constructor(private empresasService: EmpresasService, 
    private datePipe: DatePipe,
    private guiasService : GuiasService,
    private firmaElectronicaService:FirmaElectronicaService,
    private msgTitulos : MessagesTitles,
    private msgStatus:MessagesStatus,
    private comunicacionService:ComunicacionService) { 
    
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.idEmpresa = this.empresasService.pagareDatos.idEmpresa
    this.ObtenerClienteCombo()
    this.formDataEnviar = new FormGroup({
      "Fecha_Inicio": new FormControl(this.now,[Validators.required]),
      "Observaciones": new FormControl(''),
      "Correo":new FormControl('',  Validators.required),
      "IF_Representante_Legal_1": new FormControl('',  Validators.required),
      "IF_Representante_Aval": new FormControl(''),
      "idContratoMarco": new FormControl(''),
      "idOperacion": new FormControl('')
    });

    this.formTipoP = new FormGroup({      
      tipoPagare : new FormControl(false),
      Moneda : new FormControl(),
      Importe : new FormControl('0.0', [Validators.pattern('^[0-9.]+$'), Validators.minLength(2)]),
      Fecha_Fin : new FormControl(""),
      Alta_Canal : new FormControl('W', []),
      Alta_Fecha : new FormControl(this.now),
      Tieneaval : new FormControl(true),
      TipoAval : new FormControl(false),
      AvalJuridico : new FormControl()
    });    
  }

  ngOnInit() {
    this.obtenerContratosMarco(this.idEmpresa.toString(),this.empresasService.pagareDatos.Tipo_Servicio);
    this.ListarRepresentantesEmpresa(this.idEmpresa);

    this.dropdownSettings2 = {
      singleSelection: false,
      text: "Seleccione firmante del Aval",
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Desmarcar todo',
      enableSearchFilter: false,
      labelKey: 'NombreCorreo',
      primaryKey: 'idContacto',
      classes: "myclass custom-class",
      badgeShowLimit: 3
    };    
    this.dropdownSettings4 = {
      singleSelection: false,
      text: "Seleccione Firmante",
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Desmarcar todo',
      enableSearchFilter: false,
      labelKey: 'Nombre_Comercial',
      primaryKey: 'idEmpresa',
      classes: "myclass custom-class",
      badgeShowLimit: 3
    };

  }

  representanteIF(event){
    this.selectedItems = event;
  }

  representanteCLI(event){
    this.selectedItemsCLI = event;
  }

  addDataSelects(){
    this.dataEnviar.Firmantes = [];
    this.selectedItemsCLI.forEach(item => { 
      this.dataEnviar.Firmantes.push(
        {
          'Nombre_Firmante' : item.Nombre_de_Contacto,
          'Correo' : item.Correo,
          'Telefono': item.NroMovil_Laboral,
          'Tipo_Doc_Identificacion':item.Tipo_Documento_Identidad,
          'Tipo_Doc_Identificacion_Dsc':item.Tipo_Documento_Identidad_Dsc,
          'Num_Doc_Identificacion': item.Nro_Documento_Identidad,
          'Tipo_Firmante': item.Tipo_de_Contacto,
          'Cargo' : item.Des_Tipo_de_Contacto,
          'Raz_Social' : item.Razon_Social,
          'RUC' : item.Num_Doc_Identificacion,
          'Direccion': item.Direccion_Persona,
          'Distrito':item.Distrito,
         }
      )  
    });

    if(this.selectedItems2.length == 0 && this.formTipoP.controls['TipoAval'].value == true && this.formTipoP.controls['Tieneaval'].value == true) {
      this.dataEnviar.TieneAval = 1
      this.dataEnviar.Tipo_Aval = 1;
      this.AvalFilter2 = [];
      for ( let item of this.dataRepAvalJ ){        
        this.repaval.forEach((item1,index) => {
          if (item.Nombre_de_Contacto.trim() == this.repaval[index].trim()){
            this.AvalFilter2.push(item);
           }
      });      
     
    }

      this.AvalFilter2.forEach(item => { 
        this.dataEnviar.Firmantes.push(
          {
            'Nombre_Firmante' : item.Nombre_de_Contacto,
            'Correo' : item.Correo,
            'Telefono': item.NroMovil_Laboral,
            'Tipo_Doc_Identificacion':item.Tipo_Documento_Identidad,
            'Tipo_Doc_Identificacion_Dsc':item.Tipo_Documento_Identidad_Dsc,
            'Num_Doc_Identificacion': item.Nro_Documento_Identidad,
            'Tipo_Firmante': 2,
            'Cargo' : "AVAL JURIDICO",
            'Raz_Social' : item.Razon_Social,
            'RUC' : item.Num_Doc_Identificacion,
            'Direccion': item.Direccion_Persona,
            'Distrito':item.Distrito,
           }
        )  
      });
    }else if(this.selectedItems2.length > 0 && this.formTipoP.controls['TipoAval'].value == false && this.formTipoP.controls['Tieneaval'].value == true){
      this.dataEnviar.TieneAval = 1
      this.dataEnviar.Tipo_Aval = 0;
      this.selectedItems2.forEach(item => { 
        this.dataEnviar.Firmantes.push(
          {
            'Nombre_Firmante' : item.Nombre_de_Contacto,
            'Correo' : item.Correo,
            'Telefono': item.NroMovil_Laboral,
            'Tipo_Doc_Identificacion':item.Tipo_Documento_Identidad,
            'Tipo_Doc_Identificacion_Dsc':item.Tipo_Documento_Identidad_Dsc,
            'Num_Doc_Identificacion': item.Nro_Documento_Identidad,
            'Tipo_Firmante': item.Rol_del_Contacto,
            'Cargo' : item.Rol_Del_Contacto_Dsc,
            'Raz_Social' : item.Razon_Social,
            'RUC' : item.Num_Doc_Identificacion,
            'Direccion': item.Direccion_Persona,
            'Distrito':item.Distrito_Persona,
           }
        )    
      });      
    }else{
      this.dataEnviar.TieneAval = 0;
    }

    this.selectedItems.forEach(item => { 
      this.dataEnviar.Firmantes.push(item)
    });

  }

  obtenerContratosMarco(idEmpresa,tipoServicio){
    let operacion :any = [] ;
    this.empresasService.obtenerContratosMarco(idEmpresa,tipoServicio)
    .subscribe(res => {
      operacion = res;
      operacion = operacion.filter(
        state => state.Estado.toLowerCase().indexOf("a") === 0
      );    
      if(operacion.length != 0){
        this.formDataEnviar.controls['idContratoMarco'].setValue(operacion[0].IDCMarco);
      }      
    },(err: HttpErrorResponse)=> {
      if (err.error instanceof ErrorEvent) {
        console.error("Error Event");
    } else {
        this.msgStatus.getMessage(err.status);    
    }
      Swal.fire({
        title: "Ocurrió un error",
        text: "CONTRATO MARCO NO OBTENIDO. "+this.msgStatus.message ,
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      });
    });
  }

  CerrarPopUp(){
    this.cerrarNuevoP.emit();
    this.guiasService.setDataRepresentanteCLI([]);
  }

  nuevoPagare(){
    if (this.selectedItems.length == 0 || this.selectedItemsCLI.length == 0) {
      Swal.fire({
        title:"!Es necesario llenar los firmantes",
        text: '',
        type: "warning",
        allowOutsideClick : true,
        heightAuto: false        
      });
    }else{      
    this.verificar();
    this.loading = true;    
    this.empresasService.CrearPagare(this.dataEnviar).subscribe(
      res=>{
        this.loading = false;
        this.save = true;
        Swal.fire({
          title: 'Registrado con éxito',
          text: '¿Desea enviar contrato digital a keynua.?',
          type: "success",
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si',
          cancelButtonText: 'No',
          heightAuto: false
      }).then( (result) => {  
        if (result.value){
            this.dataContract = res;
            if(this.dataContract.idPagare === undefined){
              this.dataEnviarKeynua.idPagare = this.dataContract.idProceso;
            } else {
              this.dataEnviarKeynua.idPagare = this.dataContract.idPagare;
            }
            this.enviarPagareElectronico(this.dataEnviarKeynua);
          this.cerrarNuevoP.emit();
          this.refresh.emit();
        } else if (
          result.dismiss === Swal.DismissReason.cancel
      ) {
        this.cerrarNuevoP.emit();
          this.refresh.emit();
      }   
    });
    },(err: HttpErrorResponse)=> {
      this.loading=false;
      this.msgStatus.getMessage(err.status);  
      Swal.fire({
        title: this.msgTitulos.Error,
        text: "PAGARE NO CREADO. "+this.msgStatus.message ,
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      })
    })  
    }
    
  }
  verificar(){
    if (this.formTipoP.controls['tipoPagare'].value == false) {
      this.tipoP = this.ID_PAGARE_INCOMPLETO;
    }else{
      this.tipoP = this.ID_PAGARE_COMPLETO;      
    }
    this.addDataSelects();
    this.dataEnviar.Observaciones =this.formDataEnviar.controls['Observaciones'].value
    if(this.formDataEnviar.controls['idContratoMarco'].value != ''){
      this.dataEnviar.IDCMarco = this.formDataEnviar.controls['idContratoMarco'].value;
    }     
    if(this.formDataEnviar.controls['idOperacion'].value != ''){
      this.dataEnviar.idOperacion = this.formDataEnviar.controls['idOperacion'].value; 
    }
    this.dataEnviar.Fecha =this.datePipe.transform(this.formDataEnviar.controls['Fecha_Inicio'].value,'yyyy-MM-dd');
    this.dataEnviar.Tipo_Pagare = this.tipoP;
    this.dataEnviar.Alta_Usuario = this.user.Usuario;
    this.dataEnviar.Alta_Canal =this.formTipoP.controls['Alta_Canal'].value;  
    this.dataEnviar.Alta_Fecha = this.datePipe.transform(this.formTipoP.controls['Alta_Fecha'].value,'yyyy-MM-dd');
    this.dataEnviar.Tipo_Proceso = this.tipoProceso;
    this.dataEnviar.idEmpresa = this.idEmpresa;
    this.dataEnviar.Tipo_Servicio = this.empresasService.pagareDatos.Tipo_Servicio;
    if(this.dataEnviar.Tipo_Pagare == this.ID_PAGARE_COMPLETO){
      this.dataEnviar.Moneda =this.formTipoP.controls['Moneda'].value;    
      this.dataEnviar.Fecha_Vencimiento =this.datePipe.transform(this.formTipoP.controls['Fecha_Fin'].value ,'yyyy-MM-dd');    
      this.dataEnviar.Importe =this.formTipoP.controls['Importe'].value;
      if(!this.dataEnviar.Moneda || !this.dataEnviar.Fecha_Vencimiento || this.dataEnviar.Importe == "" || this.dataEnviar.Importe == "0.0"){
        Swal.fire({
          title:"ADVERTENCIA!",
          text: 'Es necesario llenar todos los campos para generar un pagare completo',
          type: "warning",
          allowOutsideClick : true,
          heightAuto: false        
        });
      }
    }    
    if(this.dataEnviar.Tipo_Pagare == this.ID_PAGARE_INCOMPLETO && this.formDataEnviar.controls['idContratoMarco'].value == ''){
      Swal.fire({
        title:"RECUERDA!",
        text: 'Para generar un pagare incompleto es necesario un contrato marco activo',
        type: "warning",
        allowOutsideClick : true,
        heightAuto: false        
      });
      return; 
    }
  }
  enviarPagareElectronico(dataEnviarKeynua){

   this.firmaElectronicaService.enviarPagareElectronico(dataEnviarKeynua).subscribe(
       res => {       
         this.showNotification('success','top','right','Documento enviado satisfactoriamente para su firma digital.');
       },err => {
        if (err.error.message) {
         this.showNotification('warning','top','right','No se pudo enviar contrato digital a keynua. \n Error: ' + err.error.message);
        }else{
         let error = "";
         error = err.error.error;
         this.showNotification('warning','top','right','No se pudo enviar contrato digital a keynua. \n Error: ' + error);
        }
      
      }
   );
 }

 tipoMoneda(event){
  this.formTipoP.controls['Moneda'].setValue(event);
}

  ListarRepresentantesEmpresa(idEmpresa){
    this.guiasService.setDataRepresentanteCLI([]);
    this.loading = true;
    this.empresasService.obtenerContactosEmpresa(idEmpresa).subscribe(
      res => {       
          this.rProvCombo = res;
          this.rAvalCombo = res;
          // Buscando tipos de Contactos --Representante Legal
          let tipoContacto: any = [];
          let guiaTipo: any;
          this.guiasService.TipoContacto.subscribe(
            response => {
              tipoContacto = response;
              guiaTipo = tipoContacto.find(state => state.Codigo.toLowerCase().indexOf('rl') === 0)
            }
          );          
          this.rProvCombo = this.rProvCombo.filter(
            state => state.Des_Estado.toLowerCase().indexOf('activo') === 0 && state.Tipo_de_Contacto === guiaTipo.idGuia
          );        
          this.guiasService.setDataRepresentanteCLI(this.rProvCombo);
        this.loading = false;
          // Buscando roles de Contactos --Aval
          let rolContacto: any = [];
          let guiaRol: any;
          this.guiasService.RolContacto.subscribe(
            response => {
              rolContacto = response;
              guiaRol = rolContacto.find(state => state.Codigo.toLowerCase().indexOf('ava') === 0)
            }
          );
          this.inputDefault2 = [];
          this.rAvalCombo.forEach(state => {
            if(state.Des_Estado.toLowerCase().indexOf('activo') === 0){
              let array: any = state.Rol_Del_Contacto_Id.split(','); 
              array.forEach(element => {
                let num =+element;
                if(num === guiaRol.idGuia){
                  state.Rol_del_Contacto = guiaRol.idGuia;
                  state.Rol_Del_Contacto_Dsc = guiaRol.Descripcion;
                  this.inputDefault2.push(state);
                }
              });
            }
          });
          this.rAvalCombo = this.inputDefault2;
          this.loading = false;
      },(err: HttpErrorResponse)=> {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
            console.error("Error Event");
        } else {
            this.msgStatus.getMessage(err.status);            
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA REPRESENTANTES NO OBTENIDO. "+this.msgStatus.message ,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        })
      }) ;
  }

  onItemSelect2(item: any) {
    this.setStatus2();
  }

  setStatus2() {
    (this.selectedItems2.length > 0) ? this.requiredField2 = true : this.requiredField2 = false;
  }

  OnItemDeSelect2(item: any) {
    this.setStatus2();
  }

  onSelectAll2(items: any) {
    this.setStatus2();
  }

  onDeSelectAll2(items: any) {
    this.selectedItems2 = [];
    this.setStatus2();
  }

  filterRecords2(textToSearch: string) {
    let tempArray = [];
     this.inputDefault2.forEach((item, index) => {
      if(item.Nombre_Firmante.indexOf(textToSearch.toLowerCase()) > -1) {
        tempArray.push(item);
      }
    })

    if(tempArray.length > 0){
      this.selectedItems2 = tempArray;
    }
  }

  EnterobtenerRucRazSocialCli(termino :string = ''){
    let RUCempresa = '';
    let idCliente = '';
    let Tipo_Doc_Identificacion = '';
    let Razon_Social = '';
    let Direccion_Fiscal = '';
    if (termino != null && termino != ''){
      let termino1 = termino.toLowerCase();                   
      for( let p of this.AvalArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){
            this.id = p.idEmpresa;
            RUCempresa =p.Num_Doc_Identificacion;
            idCliente = p.idEmpresa;
            Tipo_Doc_Identificacion = p.Tipo_Doc_Identificacion;
            Razon_Social = p.Razon_Social;
            Direccion_Fiscal = p.Direccion_Fiscal;
          }
      }

      this.formTipoP.controls['AvalJuridico'].setValue( RUCempresa);
      this.AvalTemporal.Num_Doc_Identificacion = RUCempresa;
      this.AvalTemporal.idCliente = idCliente;
      this.AvalTemporal.Tipo_Doc_Identificacion = Tipo_Doc_Identificacion;
      this.AvalTemporal.Razon_Social = Razon_Social;
      this.AvalTemporal.Direccion_Fiscal = Direccion_Fiscal;
    }
    this.LimpiarRepresentantes();

  }

  obtenerId(AvalId :string){

    this.AvalTemporal.idCliente = AvalId;
    this.formTipoP.controls['AvalJuridico'].setValue(AvalId);
    this.LimpiarRepresentantes();
  }

  ObtenerClienteCombo() {
    this.AvalArr = JSON.parse(sessionStorage.getItem('lstavlCbo'));
      this.filteredAval = this.AvalID.valueChanges.pipe(
        startWith(""),
        map(state => state ? this._filterCli(state) : this.AvalArr.slice()
        )
      );
  }

  ObtenerAvalesCombo(){
    this.empresasService.obtenerAvalJuridico().subscribe(res => {
    sessionStorage.setItem('lstavlCbo',JSON.stringify(res));
    this.ObtenerClienteCombo();
  });
  }

  private _filterCli(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.AvalArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  LimpiarRepresentantes(){
    this.search = true;
    this.allprueba.splice(0,this.allprueba.length);
    this.repaval.splice(0,this.repaval.length);
    this.repavalCrt.setValue('');
  }

  CerrarPopUpAdquirente(click:boolean){
    this.abrirAgregarAdquirente = false;
  }

  Refresh() {
    this.ngOnInit();
  }

  nuevoContacto(){
    this.empresasService.addContactoEmpresa = true;
    this.abrirAgregarAdquirente = true;
    if(this.AvalTemporal.idCliente){
      this.empresasService.pagareDatos.idAval = this.AvalTemporal.idCliente
      this.empresasService.pagareDatos.Razon_SocialAval = this.AvalTemporal.Razon_Social
    }
    this.comunicacionService.enviarData(this.empresasService.pagareDatos);
  }
 
  showNotification(type,from,align,message){
    
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

  CerrarPopUpAvalJ(click:boolean){   
    this.abrirAgregarAvalJ = false; 
  }

  nuevoAvalJH(){
    this.abrirAgregarAvalJ = true;
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allprueba.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }

  public ListarRepresentantesProv(){
    this.idAval = this.AvalTemporal.idCliente;
    if (this.idAval=='' || this.idAval== '0') {
      return
    }
    if (this.search) {
      this.idAval = this.AvalTemporal.idCliente;
      this.empresasService.obtenerContactosEmpresa(this.idAval).subscribe(
        res => { 
            this.search = false;      
            this.rAvalCombo = res;
  
            this.rAvalCombo = this.rAvalCombo.filter(
              state => state.Des_Estado.toLowerCase().indexOf('activo') === 0 
            );
            this.dataRepAvalJ = this.rAvalCombo
            for(let item of this.dataRepAvalJ){
              this.allprueba.splice(1,0,item.Nombre_de_Contacto);
            }
          this.filteredRepAvalJ = this.repavalCrt.valueChanges.pipe(
          startWith(null),
          map((fruit: string | null) => fruit ? this._filter(fruit) : this.allprueba.slice()));          
        },(err: HttpErrorResponse)=> {
          if (err.error instanceof ErrorEvent) {
            console.error("Error Event");
        } else {
            this.msgStatus.getMessage(err.status);            
        }
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "REPRESENTANTES NO OBTENIDO. "+this.msgStatus.message ,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        });
    }else{
      return;
    }  
    }
    
    add(event: MatChipInputEvent): void {
      const input = event.input;
      const value = event.value;
      if ((value || '').trim() && this.repaval.length < 3) {
        this.repaval.push(value.trim());
      }
      if (input) {
        input.value = '';
      }
      this.repavalCrt.setValue(null);
    }
  
    remove(fruit: string): void {
      const index = this.repaval.indexOf(fruit);
      if (index >= 0) {
        this.repaval.splice(index, 1);
      }
    }
  
    selected(event: MatAutocompleteSelectedEvent): void {
      if (this.repaval.length < 3) {
      this.repaval.push(event.option.viewValue);
      this.repavalCrt.setValue(null);
      }
    }
    
    validarCampos(){
      if (this.formTipoP.controls['tipoPagare'].value == false){
        this.formTipoP.controls['Importe'].setValue('');
        this.formTipoP.controls['Fecha_Fin'].setValue('');
        this.selectedItems2 = [];
        this.AvalID.setValue('');
        this.obtenerId('');
        this.LimpiarRepresentantes();
        this.repaval = [];
        this.formTipoP.controls['Tieneaval'].setValue(false);
        this.formTipoP.controls['TipoAval'].setValue(false)
      }  
    }

    validarTieneAval(){
      if (this.formTipoP.controls['Tieneaval'].value == false){
        this.selectedItems2 = [];
        this.AvalID.setValue('');
        this.obtenerId('');
        this.LimpiarRepresentantes();
        this.repaval = [];
      }  
    }
    validarAval(){
      if (this.formTipoP.controls['TipoAval'].value == true){
        this.selectedItems2 = [];
      }else{        
        this.AvalID.setValue('');
        this.obtenerId('');
        this.LimpiarRepresentantes();
        this.repaval = [];
      }
    }

}

